// extracted by mini-css-extract-plugin
export default {"loadingBox":"LoadingBox_loadingBox__SBY6Z"};